function processAnnouncementBarItems() {
  document.querySelectorAll('[data-translated-str]').forEach(function (el) {
    var translatedStr = el.dataset.translatedStr;
    if (!translatedStr) return;

    var useShippingGoal = el.dataset.useShippingGoal === 'true';
    var translatedKey1 = el.dataset.translatedKey1 || '';

    if (useShippingGoal) {
      var currencyRate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
      translatedKey1 = ((parseFloat(translatedKey1) * currencyRate * 100) / 100).toFixed(2);
      var moneyFormat =
        window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.moneyWithCurrencyFormat;
      if (moneyFormat) {
        translatedKey1 = moneyFormat.replace(/\{\{.+\}\}/, translatedKey1);
      }
    }

    el.innerHTML = translatedStr.replace(/\{\{ key1 \}\}/, translatedKey1);
  });
}

function setAnnouncementBarHeight() {
  var bar = document.querySelector('.shopify-section--announcement-bar');
  if (bar) {
    document.documentElement.style.setProperty('--announcement-bar-height', bar.clientHeight + 'px');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  processAnnouncementBarItems();
  setAnnouncementBarHeight();
});
